export default __webpack_public_path__ + "static/media/banner3.8c6f9d16.png";